import React from 'react'
import PropTypes from 'prop-types'

const BookmarkRow = ({
  bookmark,
  handleAddressClick,
  handleCopyClick,
  handleDeleteClick,
}) => {

  return (
    <div className="bookmark-row margin-top-md margin-btm-md" data-id={bookmark.id}>
      <a href='#' onClick={(e) => handleAddressClick(e, bookmark)}>{bookmark.address}</a>
      <div className="bookmark-row-btns">
        <button className="btn btn-xs btn-round btn-inline" title="Copy bookmark to clipboard" onClick={() => handleCopyClick(bookmark.path)}>
          <i className="fas fa-copy"></i>
        </button>
        <button className="btn btn-xs btn-round btn-inline" title="Remove bookmark" onClick={() => handleDeleteClick(bookmark.path, bookmark.source_id)}>
          <i className="fas fa-trash"></i>
        </button>
      </div>
    </div>
  )
}

BookmarkRow.propTypes = {
  bookmark:           PropTypes.object.isRequired,
  handleAddressClick: PropTypes.func.isRequired,
  handleCopyClick:    PropTypes.func.isRequired,
  handleDeleteClick:  PropTypes.func.isRequired,
}

export default BookmarkRow
